export type {
  ButtonStateStyleInterface,
  LoyaltyStatusStyleInterface,
} from './LoyaltyStatusBar'
export { LoyaltyStatusBar } from './LoyaltyStatusBar'
